// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';

// function Home() {
//   const navigate = useNavigate();
//   const [userId, setUserId] = useState(''); // useState setter

//   useEffect(() => {
//     const isLoggedIn = localStorage.getItem('isLoggedIn');
//     const storedUser = localStorage.getItem('userC');
//     if (!isLoggedIn) {
//       navigate('/login'); // redirect to login if not logged in
//     } else if (storedUser) {
//       // Parse user object and set userId
//       try {
//         const userObj = JSON.parse(storedUser);
//         if (userObj.user_id) setUserId(userObj.user_id);
        
//       } catch {
//         // In case parsing fails, force logout
//         localStorage.removeItem('isLoggedIn');
//         localStorage.removeItem('user');
//         navigate('/login');
//       }
//     }
//   }, [navigate]);

//   return (
//     <div style={{ padding: '20px' }}>
//       <h2>Welcome to the Home Page!  {userId}</h2>
//       <button
//         onClick={() => navigate('/admin')}
//         style={{ padding: '10px 20px', marginTop: '20px' }}
//       >
//         Go to Admin Page
//       </button>
//       <button
//         onClick={() => navigate('/profile')}
//         style={{ padding: '10px 20px', marginTop: '20px' }}
//       >
//         Go to your Profile Page
//       </button>
//     </div>
//   );
// }

// export default Home;

import React, { useEffect, useState } from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function Home() {
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState('');
  const [username, setUsername] = useState('');

  // On mount, check login and role
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    const storedUser = localStorage.getItem('userC');

    if (!isLoggedIn || !storedUser) {
      navigate('/login');
    } else {
      try {
        const userObj = JSON.parse(storedUser);
        if (!userObj.user_id || !userObj.role) {
          throw new Error();
        }
        setUserRole(userObj.role.toLowerCase());
        setUsername(userObj.username);
      } catch {
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('userC');
        navigate('/login');
      }
    }
  }, [navigate]);

  const sectionsByRole = {
    admin: [
      { label: 'Customers', path: 'StaffPages/customers' },
      { label: 'User Management', path: '/users' },
      { label: 'Product Management', path: '/products' },
      
    ],
    ordertaker: [
      { label: 'Customers', path: '/customers' },
    ]
  };

  const sections = sectionsByRole[userRole] || [];

  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Welcome, {username}
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Role: {userRole.toUpperCase()}
      </Typography>

      <Grid container spacing={3} mt={2}>
        {sections.map((section) => (
          <Grid item xs={12} sm={6} md={4} key={section.label}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: 'center',
                cursor: 'pointer',
                transition: '0.3s',
                '&:hover': {
                  boxShadow: 6,
                  backgroundColor: 'primary.light',
                },
              }}
              onClick={() => navigate(section.path)}
            >
              <Typography variant="h6">{section.label}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Home;
